module.exports = __webpack_public_path__ + "img/moqing.062db28b.png";